import { Helmet } from 'react-helmet-async';
import InfoSection from './InfoSection/InfoSection'
import IntroSection from './IntroSection/IntroSection'
import ContactSection from './ContactSection/ContactSection'
import classes from './HomePage.module.css'
import { Link } from 'react-router-dom';


function HomePage() {
    return (
        <>
            <Helmet>
                <title>Tabufy | המרת נסח טאבו לאקסל (Excel) באופן אוטומטי ומדויק</title>
                <meta name="description" content="הדרך המהירה ביותר לניתוח נסחי טאבו. העלו נסח PDF וקבלו קובץ אקסל מסודר תוך שניות. שירות מותאם למקצועני נדל&quot;ן, שמאים ועורכי דין." />
                <link rel="canonical" href="https://www.tabu-fy.com/" />
                <meta property="og:title" content="Tabufy | המרת נסח טאבו לאקסל (Excel) באופן אוטומטי ומדויק" />
                <meta property="og:description" content="הדרך המהירה ביותר לניתוח נסחי טאבו. העלו נסח PDF וקבלו קובץ אקסל מסודר תוך שניות." />
                <meta property="og:url" content="https://www.tabu-fy.com/" />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:image" content="https://www.tabu-fy.com/icon.png" />
            </Helmet>
            <IntroSection/>
            <InfoSection/>
            <ContactSection/>
        </>
    )
}

export default HomePage
